module.exports = {"menu_entries":{"campaigns":"Kampagnen"}}